import create from 'zustand';
import BigNumber from 'bignumber.js';
import io from 'socket.io-client';
import config from 'config';
import apiClient from './helpers/apiClient';

export default create(set => ({
  socket: io(config.chatEndpoint),

  user: { isLoading: false, data: null },
  setUserData: newData => set(state => ({
    user: { ...state.user, data: { ...state.user.data, ...newData } },
  })),
  setUserIsLoading: isLoading => set(state => ({ user: { ...state.user, isLoading } })),

  asset: {
    selected: 'BSV',
    balance: { BSV: new BigNumber(0), PGP: new BigNumber(0) },
    isLoading: true,
  },
  getAssetBalance: async () => {
    const { data } = await apiClient().get('/v1/wallets/balance');
    const newBalance = data.reduce(
      (accumulator, { asset, amount }) => ({
        ...accumulator,
        [asset]: new BigNumber(amount),
      }),
      {}
    );
    set(state => ({
      asset: { ...state.asset, isLoading: false, balance: newBalance },
    }));
  },
  setAssetIsLoading: isLoading => set(state => ({ asset: { ...state.asset, isLoading } })),
  setSelectedAsset: selected => set(state => ({ asset: { ...state.asset, selected } })),
  setAssetBalance: updateFunc => set(({ asset }) => ({
    asset: {
      ...asset,
      balance: { ...asset.balance, ...updateFunc(asset.balance) },
    },
  })),

  showDepositModal: false,
  setShowDepositModal: showDepositModal => set({ showDepositModal }),

  isAdult: null,
  setIsAdult: isAdult => set({ isAdult }),
}));
